import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Company Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center shadow-lg">
          <Icon name="Zap" size={32} color="white" />
        </div>
      </div>
      
      {/* Company Name and Tagline */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-foreground">
          Ecomotech
        </h1>
        <p className="text-lg text-muted-foreground font-medium">
          Enterprise Resource Planning
        </p>
      </div>
      
      {/* Welcome Message */}
      <div className="mt-6 space-y-1">
        <h2 className="text-xl font-semibold text-foreground">
          Welcome Back
        </h2>
        <p className="text-sm text-muted-foreground">
          Sign in to access your ERP dashboard
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;